import Model from "../Model";

export interface TReferenceValue {
  id?: string;
  value: string;
}

export interface IReferenceValue extends TReferenceValue {}

const ReferenceValue = Model(
  (model: TReferenceValue): IReferenceValue => {
    const _referenceValue: TReferenceValue = Object.assign({}, model);

    return {
      get id() {
        return _referenceValue.id;
      },

      get value() {
        return _referenceValue.value;
      }
    };
  }
);

export default ReferenceValue;
